"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrowFactoryCallerMock__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [{
    internalType: "address",
    name: "titleEscrowFactory",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "callCreate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "0x608060405234801561001057600080fd5b50610162806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c80637cf99ced14610030575b600080fd5b61004361003e3660046100dc565b610045565b005b604051631e02403760e21b8152600481018290526001600160a01b0383169063780900dc90602401602060405180830381600087803b15801561008757600080fd5b505af115801561009b573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906100bf9190610108565b505050565b6001600160a01b03811681146100d957600080fd5b50565b600080604083850312156100ef57600080fd5b82356100fa816100c4565b946020939093013593505050565b60006020828403121561011a57600080fd5b8151610125816100c4565b939250505056fea2646970667358221220f803e1157bbf2d48c466fb0e677f76280518c3d361005349f5f2f0d7097a9f5464736f6c63430008090033";

const isSuperArgs = xs => xs.length > 1;

class TitleEscrowFactoryCallerMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TitleEscrowFactoryCallerMock__factory = TitleEscrowFactoryCallerMock__factory;

_defineProperty(TitleEscrowFactoryCallerMock__factory, "bytecode", _bytecode);

_defineProperty(TitleEscrowFactoryCallerMock__factory, "abi", _abi);